<template>
  <div>

    <body data-anchor="pagetop" class="home page-template-default page page-id-314 wp-embed-responsive st-Grid_Container" style="overflow-y: unset;background-color: #f5f7f7;">
      <navbar follow="st-Header" imgSrc="../../../../static/img/landing/logo_black.png" searchImgSrc="../../../../static/img/landing/search_black.png"></navbar>
      <div class="st-MainContainer">
        <main class="st-MainContents" style="padding-top:120px;">
          <header class="news-PageTitle">
            <div class="news-PageTitle_Inner">
              <h1 class="sw-Section_Header appear" data-appear>
                <span class="sw-Section_Header-en"><b>PRIVACY POLICY</b></span>
                <span class="sw-Section_Header-ja"><b>プライバシーポリシー</b></span>
              </h1>
            </div>
          </header>
          <section class="policy-Block">
            <div class="policy-Block_Inner">
              <div>
                <p>ナイスセラ株式会社は、個人情報保護の重要性に鑑み、以下のとおりプライバシーポリシーを定めています。</p>
              </div>
              <div>
                <h2>個人情報保護体制の確立</h2>
                <p>当社は、役員及び従業員に個人情報保護の重要性を認識させ、個人情報を適切に保護するための体制を確立します。</p>
              </div>
              <div>
                <h2>個人情報の取得・利用・提供等</h2>
                <p>当社は、当社における個人情報の取得、利用、提供等に関して諸規則を策定し、これに基づき個人情報を適切に取り扱います。</p>
              </div>
              <div>
                <h2>安全管理措置</h2>
                <p>当社は、個人情報の正確性及び安全性を確保するため、情報セキュリティ対策をはじめとする安全管理措置を講じ、個人情報への不正アクセス、または個人情報の紛失、破壊、改ざん、漏えい等の予防に努めます。</p>
              </div>
              <div>
                <h2>情報主体の権利尊重</h2>
                <p>当社は、個人情報に関する情報主体の権利を尊重し、ご本人から自己情報の開示、内容の訂正、追加または削除、消去及び第三者への提供の停止を求められたときは、法令の定めに従いこれに応じます。</p>
              </div>
              <div>
                <h2>法令の遵守</h2>
                <p>当社は、個人情報の取扱いにおいて個人情報の保護に関する法律及び関連する政省令並びにその他のガイドラインを遵守します。</p>
              </div>
              <div>
                <h2>利用目的について</h2>
                <p>当社は、お客様の住所、氏名等の個人情報（お客様と当社との取引に関する情報を含み、以下「個人情報」といいます。）を下記の目的で利用いたします。なお、当社は、あらかじめお客様ご本人の同意を得ることなく、下記目的以外にお客様の個人情報を利用することはありません。</p>
                <ul>
                  <li>当社が取扱う商品・サービス等について、または各種イベント・キャンペーン等の開催について、宣伝印刷物の送付、電話、電子メールの送信等によりご案内すること。</li>
                  <li>商品開発またはお客様満足度向上策等の検討のために、アンケート調査を実施すること。</li>
                  <li>お客様の個人情報を書面または電子媒体により下記の第三者に提供する事。但し、お客様ご本人のお申出があった場合、第三者提供を停止いたします。</li>
                  <li>採用に関する各種連絡・お知らせの配信。提供先：当社の関連会社並びに当社。但し、ウェブサイト、書面等により、別途の利用目的が公表されている場合、または取得に当たり、お客様に利用目的を明示した場合においては、その利用目的が優先されるものとします。</li>
                </ul>
              </div>
              <div>
                <h2>個人情報の開示、訂正等について</h2>
                <p>当社は、個人情報の保護に関する法律に基づき、当社が保有する個人情報に関して、お客様ご本人から開示、訂正等のご請求があった場合には、適切に対応いたします。開示、訂正等のご請求方法につきましては、以下のとおりとします。</p>
                <ul>
                  <li>当ウェブサイトのお問い合わせ窓口にご連絡ください。</li>
                  <li>お問い合わせ内容を確認させていただき、当社より開示・訂正等の請求書をお送りいたします。<br>
                    <span>※その際、開示・訂正等の請求書・請求方法案内状を発送するために、氏名・住所等をお伺いします。</span>
                  </li>
                  <li>開示・訂正等の請求書到着後、当該請求書に必要事項をご記入の上、本人確認するための書類を同封して請求方法案内状記載の宛先にご郵送ください。<br>
                    <span>
                      ※ご本人を確認するための書類：運転免許証のコピー、住民票の写し等。<br>
                      ※行政機関等で本人確認書類を入手する際の手数料、コピー代及びご郵送に係る費用はお客様のご負担となります。
                    </span>
                  </li>
                  <li>上記書類の受領後、２週間を目処に当社より書面にてご回答いたします。</li>
                </ul>
              </div>
            </div>
          </section>
        </main>
        <div class="st-Breadcrumbs">
          <ul class="st-BreadcrumbsList" itemscope="itemscope" itemtype="">
            <li class="st-BreadcrumbsList_Item" itemprop="itemListElement" itemscope="itemscope" itemtype="">
              <a class="st-BreadcrumbsList_Item-link" href="/" itemprop="item">ホーム</a>
              <meta itemprop="position" content="1">
            </li>
            <li class="st-BreadcrumbsList_Item" itemprop="itemListElement" itemscope="itemscope" itemtype="">
              <p itemprop="item" aria-current="page" style="margin-bottom: 0rem;"><span itemprop="name">プライバシーポリシー</span></p>
              <meta itemprop="position" content="3">
            </li>
          </ul>
        </div>
      </div>
      <copyright></copyright>
    </body>
  </div>
</template>
<style />
<script type="text/javascript">
import copyright from './../copyright'
import navbar from './../navbar'

export default {
  components: { copyright, navbar },
  data: function () {
    return {
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      $(document).scroll(() => {
        let scroH = $(document).scrollTop()
        let viewW = $(window).width()
        console.log(scroH)
        if (scroH > 50) {
          $('.st-Header').addClass('is-follow')
          $('.st-Footer_Pagetop').addClass('is-follow')
        } else {
          $('.st-Header').removeClass('is-follow')
          $('.st-Footer_Pagetop').removeClass('is-follow')
        }

        if (viewW > 769) {
          if (scroH >= 200) {
            $('.sw-Section_Header').eq(0).removeClass('appear')
          } else {
            $('.sw-Section_Header').eq(0).addClass('appear')
          }
        } else {
        }

        // appear
      })
    }
  }
}
</script>
<style scoped>
  .home>>>.st-Nav_List-en {
    color: #222;
  }

  .home>>> .st-Nav_List-ja {
    color: #222;
  }
  .home>>> .st-Header {
    background-color: #fff;
    border-bottom: 1px solid #ddd;
    transition: height .2s ease-in-out;
  }

  a {
    border-bottom-style: none;
  }

  .sw-ButtonRound a {
    padding: 18px 50px;
    min-width: 160px;
    background-color: #c7000b;
  }

  .sw-ButtonRound a span {
    margin-left: -25px
  }

  .sw-ButtonRound a span,
  .sw-ButtonRound a i {
    background-color: #c7000b;
    color: #FFFFFF;
  }

  .news-Narrow>>>.el-input__inner {
    border-radius: 100px;
    width: 120px;
    border-color: #04192A;
  }

  .is-active {
    background-color: #04192A !important;
  }

  .top-Product_Image-inner img {
    width: 100%
  }

  .swiper-slide-news {
    width: 360px !important;
    margin-right: 60px !important;
    margin-left: 36px !important;
  }

  .news-Narrow_Cate li {
    border-radius: 100px;
  }

  .news-Narrow_Cate li a {
    transition: none;
    border-radius: 100px;
  }

  @media (hover: hover) {
    .news-Narrow_Cate li a:hover {
      border-radius: 100px;
      transition: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/policy/privacy.vue